<template>
  <svg width="4" height="8" viewBox="0 0 4 8" class="custom-icon" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 0C0 0 0.333333 2 2 2C3.66667 2 4 0 4 0V8C4 8 3.66667 6 2 6C0.333333 6 0 8 0 8V0Z"
      fill="#FFF"
    />
  </svg>
</template>
